import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SectionHead } from "@/components/Reveal";
import ProductCard from "@/components/ProductCard";
import { LINES, PRODUCTS, lineById } from "@/data/products";
import ZipCTA from "@/components/denim/ZipCTA";

export default function TabsSection({ onQuickView }) {
    const [active, setActive] = useState("everyday");
    const list = PRODUCTS.filter((p) => p.line === active).slice(0, 4);
    const line = lineById(active);

    return (
        <section className="border-y border-white/10 bg-coal/40 py-24 md:py-32">
            <div className="mx-auto w-full max-w-[1400px] px-5 md:px-8 lg:px-10">
                <SectionHead eyebrow="Engineered Denim" title="The Line-Up" sub={line ? line.sub : ""} />
                <div className="mt-10 flex flex-wrap gap-1 border-b border-white/10" data-testid="line-tabs">
                    {LINES.map((l) => {
                        const isActive = active === l.id;
                        return (
                            <button
                                key={l.id}
                                data-testid={`product-tab-${l.id}`}
                                onClick={() => setActive(l.id)}
                                className={`relative px-4 py-3 font-mono text-[11px] uppercase tracking-[0.18em] transition-colors md:px-5 md:text-xs ${
                                    isActive ? "text-gold" : "text-mute hover:text-ink"
                                }`}
                            >
                                {l.name}
                                {isActive && (
                                    <motion.span
                                        layoutId="tab-underline"
                                        className="absolute inset-x-0 bottom-0 h-[2px] bg-gold"
                                        transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
                                    />
                                )}
                            </button>
                        );
                    })}
                </div>
                <AnimatePresence mode="wait">
                    <motion.div
                        key={active}
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -16 }}
                        transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
                        className="mt-12 grid grid-cols-2 gap-5 md:gap-8 lg:grid-cols-4"
                    >
                        {list.map((p, i) => (
                            <ProductCard key={p.id} p={p} index={i} onQuickView={onQuickView} />
                        ))}
                    </motion.div>
                </AnimatePresence>
                <div className="mt-14 text-center">
                    <ZipCTA to={`/shop?line=${active}`} testid="tabs-shop-now">
                        Shop {line ? line.name : "All"}
                    </ZipCTA>
                </div>
            </div>
        </section>
    );
}
